import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { reducer as toastrReducer } from 'react-redux-toastr';
import { authReducer } from './auth';
import { usersReducer } from './users';
import { organizationsReducer } from './organizations';
import { sitesReducer } from './sites';
import { screensReducer } from './screens';
import { configsReducer } from './configuration';
import { filesReducer } from './files';
import { poisReducer } from './pois';
import { categoriesReducer } from './categories';
import { mediaCategoriesReducer } from './mediaCategories';
import { mediaReducer } from './media';
import { preferencesReducer } from './preferences';
import { mapsReducer } from './maps';
import { mapsStaticReducer } from './mapsStatic';
import { feedbackReducer } from './feedback';
import { respondentReducer } from './respondent';
import { screenshotReducer } from './screenshot';
import { informationReducer } from './information';
import { informationCategoriesReducer } from './informationCategories';
import { logsReducer } from './log';
import { tabReducer } from './tab';
// import { configReducer } from './config';
import { settingsReducer } from './settings';
import { notificationReducer } from './notification';
import { floorReducer } from './floors';
import { playlistReducer } from './playlist';
import { roleReducer } from './roles';
import { panelReducer } from './panel';
import { menuReducer } from './menu';
import { screenusersReducer } from './screenusers';
import { breadcrumbReducer } from './breadcrumb';
import { mapviewerReducer } from './mapviewer';
import { analyticReducer } from './analytic';
import { eventReducer } from './event';
import { dealReducer } from './deal';
import { directoriesReducer } from './directories';
import { syncedCategoriesReducer } from './syncedCategories';
import { overviewReducer } from './overview';
import { tenantsReducer } from './tenants';
import { tagReducer } from './tags';
import { subCategoriesReducer } from './subCategories';
import { screenGroupReducer } from './screenGroup';
import { poiDirectoriesReducer } from './poiDirectories';
import { mediaAnalyticsReducer } from './mediaAnalytic';

export default combineReducers({
  analytic: persistReducer(
    {
      key: 'analytic',
      storage,
      blacklist: ['error', 'loading'],
    },
    analyticReducer
  ),
  auth: persistReducer(
    {
      key: 'auth',
      storage,
      blacklist: ['error', 'loading'],
    },
    authReducer
  ),
  breadcrumb: breadcrumbReducer,
  categories: persistReducer(
    {
      key: 'categories',
      storage,
      blacklist: ['error', 'loading', 'category'],
    },
    categoriesReducer
  ),
  config: persistReducer(
    {
      key: 'config',
      storage,
      blacklist: ['error', 'loading'],
    },
    configsReducer
  ),
  deals: persistReducer(
    {
      key: 'deals',
      storage,
      blacklist: ['error', 'loading'],
    },
    dealReducer
  ),
  directories: persistReducer(
    {
      key: 'directories',
      storage,
      blacklist: ['error', 'loading'],
    },
    directoriesReducer
  ),
  events: persistReducer(
    {
      key: 'events',
      storage,
      blacklist: ['error', 'loading'],
    },
    eventReducer
  ),
  feedback: persistReducer(
    {
      key: 'feedback',
      storage,
      blacklist: ['error', 'loading'],
    },
    feedbackReducer
  ),
  files: persistReducer(
    {
      key: 'files',
      storage,
      blacklist: ['error', 'warning'],
    },
    filesReducer
  ),
  floor: persistReducer(
    {
      key: 'floor',
      storage,
      blacklist: ['error', 'loading'],
    },
    floorReducer
  ),
  information: persistReducer(
    {
      key: 'information',
      storage,
      blacklist: ['error', 'loading', 'information'],
    },
    informationReducer
  ),
  informationCategories: persistReducer(
    {
      key: 'informationCategories',
      storage,
      blacklist: ['error', 'loading', 'category'],
    },
    informationCategoriesReducer
  ),
  logs: persistReducer(
    {
      key: 'logs',
      storage,
      blacklist: ['error', 'loading'],
    },
    logsReducer
  ),
  maps: persistReducer(
    {
      key: 'maps',
      storage,
      blacklist: ['error', 'loading'],
    },
    mapsReducer
  ),
  mapsStatic: persistReducer(
    {
      key: 'mapStatic',
      storage,
      blacklist: ['error', 'loading'],
    },
    mapsStaticReducer
  ),
  mapviewer: persistReducer(
    {
      key: 'mapviewer',
      storage,
      blacklist: ['error', 'loading'],
    },
    mapviewerReducer
  ),
  media: persistReducer(
    {
      key: 'media',
      storage,
      blacklist: ['error', 'loading', 'media'],
    },
    mediaReducer
  ),
  mediaCategories: persistReducer(
    {
      key: 'mediaCategories',
      storage,
      blacklist: ['error', 'loading'],
    },
    mediaCategoriesReducer
  ),
    mediaanalytic: persistReducer(
    {
      key: 'mediaanalytic',
      storage,
      blacklist: ['error', 'loading'],
    },
    mediaAnalyticsReducer
  ),
  menu: persistReducer(
    {
      key: 'menu',
      storage,
    },
    menuReducer
  ),
  notifications: persistReducer(
    {
      key: 'notifications',
      storage,
      blacklist: ['error', 'loading'],
    },
    notificationReducer
  ),
  organizations: persistReducer(
    {
      key: 'organizations',
      storage,
      blacklist: ['error', 'loading'],
    },
    organizationsReducer
  ),
  overview: persistReducer(
    {
      key: 'overview',
      storage,
      blacklist: ['error', 'loading'],
    },
    overviewReducer
  ),
  panel: persistReducer(
    {
      key: 'panel',
      storage,
      blacklist: ['error', 'loading'],
    },
    panelReducer
  ),
  playlist: persistReducer(
    {
      key: 'playlist',
      storage,
      blacklist: ['error', 'loading'],
    },
    playlistReducer
  ),
  poidirectories: persistReducer(
    {
      key: 'poidirectories',
      storage,
      blacklist: ['error', 'loading'],
    },
    poiDirectoriesReducer
  ),
  pois: persistReducer(
    {
      key: 'pois',
      storage,
      blacklist: ['error', 'loading'],
    },
    poisReducer
  ),
  preferences: persistReducer(
    { key: 'preferences', storage },
    preferencesReducer
  ),
  respondent: persistReducer(
    {
      key: 'respondent',
      storage,
      blacklist: ['error', 'loading'],
    },
    respondentReducer
  ),
  roles: persistReducer(
    {
      key: 'roles',
      storage,
      blacklist: ['error', 'loading'],
    },
    roleReducer
  ),
  screengroup: persistReducer(
    {
      key: 'screengroup',
      storage,
      blacklist: ['error', 'loading'],
    },
    screenGroupReducer
  ),
  screens: persistReducer(
    {
      key: 'screens',
      storage,
      blacklist: ['error', 'warning'],
    },
    screensReducer
  ),
  screenshot: persistReducer(
    {
      key: 'screenshot',
      storage,
      blacklist: ['error', 'loading'],
    },
    screenshotReducer
  ),
  screenusers: persistReducer(
    {
      key: 'screenusers',
      storage,
      blacklist: ['error', 'loading'],
    },
    screenusersReducer
  ),
  settings: persistReducer(
    {
      key: 'settings',
      storage,
      blacklist: ['error', 'loading'],
    },
    settingsReducer
  ),
  sites: persistReducer(
    {
      key: 'sites',
      storage,
      blacklist: ['error', 'loading'],
    },
    sitesReducer
  ),
  subcategories: persistReducer(
    {
      key: 'subcategories',
      storage,
      blacklist: ['error', 'loading'],
    },
    subCategoriesReducer
  ),
  syncedCategories: persistReducer(
    {
      key: 'syncedCategories',
      storage,
      blacklist: ['error', 'loading'],
    },
    syncedCategoriesReducer
  ),
  tab: tabReducer,
  tags: persistReducer(
    {
      key: 'tags',
      storage,
      blacklist: ['error', 'loading'],
    },
    tagReducer
  ),
  tenants: persistReducer(
    {
      key: 'pois',
      storage,
      blacklist: ['error', 'loading'],
    },
    tenantsReducer
  ),
  toastr: toastrReducer,
  users: persistReducer(
    {
      key: 'users',
      storage,
      blacklist: ['error', 'loading'],
    },
    usersReducer
  ),
});
